import { useState } from 'react';
import { api } from '../api/client';
import type { CreateTaskRequest } from '@spirtech/shared';

export interface TaskOption {
	id: number;
	name: string;
	isActive: boolean;
}
export interface ProjectOption {
	id: number;
	name: string;
	client: string | null;
}

export function useTasks() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const createTask = async (body: CreateTaskRequest) => {
		setLoading(true);
		try {
			return await api.post<{ id: number; name: string }>('/tasks', body);
		} catch (e: any) {
			setError(e.message);
		} finally {
			setLoading(false);
		}
	};

	const deleteTask = async (id: number) => {
		setLoading(true);
		try {
			await api.delete(`/tasks/${id}`);
		} catch (e: any) {
			setError(e.message);
		} finally {
			setLoading(false);
		}
	};

	// Move a task to another project. Throws on failure so callers can surface
	// the message (e.g. name clash in the target project) rather than swallowing it.
	const moveTask = (inId: number, inProjectId: number) =>
		api.patch<{ ok: boolean; projectId: number }>(`/tasks/${inId}/project`, { projectId: inProjectId });

	const fetchProjects = () => api.get<ProjectOption[]>('/tasks/my-projects');

	const fetchTasks = (projectId: number) => api.get<TaskOption[]>(`/tasks?projectId=${projectId}`);

	return { createTask, deleteTask, moveTask, fetchProjects, fetchTasks, loading, error };
}
